import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import breakpoints from "assets/theme/base/breakpoints";
import boy from "../../../../assets/images/boy.png";
import books from "../../../../assets/images/background/books_bg.png";
import { setOpenConfigurator } from "context";
import { useMaterialUIController } from "context";
import { useUpdateUserMutation } from "App/services/userServiceApi";

function Header({ children }) {

  const user = JSON.parse(localStorage.getItem('user')) || {}; 

  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [controller, dispatch] = useMaterialUIController();
  const { openConfigurator } = controller;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [name, setName] = useState(user[0].name || ""); 
  const [email, setEmail] = useState(user[0].email || ""); 
  const [password, setPassword] = useState(""); 
  const [mobile, setMobile] = useState(user[0].mobile || ""); 

  const [updateUser, { isLoading }] = useUpdateUserMutation();

  const handleEditUser = async (event) => {
    // console.log("object")
    event.preventDefault();
    try {
    const updatedUser = { id: user[0].id, name, email, password, mobile };
    // console.log([updatedUser])
      await updateUser(updatedUser);

      // localStorage.setItem('user', JSON.stringify(updatedUser));
      setOpen(false);
      // Handle success feedback or further navigation
    } catch (error) {
      console.error('Failed to update user:', error);
      // Handle error feedback
    }
  };

  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    function handleTabsOrientation() {
      setTabsOrientation(window.innerWidth < breakpoints.values.sm ? "vertical" : "horizontal");
    }

    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();

    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, []);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);
  const handleAppTabClick = () => navigate('/dashboard');

  return (
    <MDBox position="relative" mb={5}>
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="18.75rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.info.main, 0.6),
              rgba(gradients.info.state, 0.6)
            )}, url(${books})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      />
      <Card sx={{ position: "relative", mt: -8, mx: 3, py: 2, px: 2 }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <MDAvatar src={boy} alt="profile-image" size="xl" shadow="sm" />
          </Grid>
          <Grid item>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography variant="h5" fontWeight="medium">
                {user[0].name}
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4} sx={{ ml: "auto" }}>
            <AppBar position="static">
              <Tabs orientation={tabsOrientation} value={tabValue} onChange={handleSetTabValue}>
                <Tab
                  label="App"
                  icon={<Icon fontSize="small" sx={{ mt: -0.25 }}>home</Icon>}
                  onClick={handleAppTabClick}
                />
                <Tab
                  label="Settings"
                  icon={<Icon fontSize="small" sx={{ mt: -0.25 }}>settings</Icon>}
                  onClick={() => setOpenConfigurator(dispatch, !openConfigurator)}
                />
                {/* <Tab
                  label="Edit Profile"
                  icon={<Icon fontSize="small" sx={{ mt: -0.25 }}>edit</Icon>}
                  onClick={() => setOpen(true)}
                /> */}
              </Tabs>
            </AppBar>
          </Grid>
        </Grid>
        {children}
      </Card>

      <Dialog  open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: handleEditUser,
        }}>
        <DialogTitle>Edit Profile</DialogTitle>
        <DialogContent>
          <MDBox component="form" onSubmit={handleEditUser}>
            <TextField
              autoFocus
              margin="dense"
              label="Name"
              variant="standard"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <TextField
              margin="dense"
              label="Email"
              variant="standard"
              fullWidth
              disabled
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              margin="dense"
              label="Mobile"
              variant="standard"
              fullWidth
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
            />
            <TextField
              margin="dense"
              label="Password"
              type="password"
              variant="standard"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button type="submit" disabled={isLoading}>
            {isLoading ? 'Updating...' : 'Update'}
          </Button>
        </DialogActions>
      </Dialog>
    </MDBox>
  );
}

// Setting default props for the Header
Header.defaultProps = {
  children: "",
};

// Typechecking props for the Header
Header.propTypes = {
  children: PropTypes.node,
};

export default Header;
